export default {
  celular: '(##) #####-####',
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  cep: '##.###-###',
  data: '##/##/####',
  mes: '##/####',
  hora: '##:##',
};
